// Frontend/src/data/storeItems.js

const storeItems = [
  {
    id: 1,
    name: "GarmentTicket",
    image: "https://vexconquer.site/files1/items/garmentlogo.png",
    price: 5,
    category: "SpecialGarment",
    description: "1 ticket for normal garment, 2 tickets for Special Garment and 3 tickets for Legendary Garments.",
  },
  {
    id: 2,
      name: "MiraculousGourd", //miraculous gourd
    image: "https://vexconquer.site/files1/items/mira.png",
    price: 25,
      category: "MiraculousGourd",
      description: "As a precious talisman will increase the ceiling of both your HP and Magic Power by 800 once equipped.",
  },
  {
    id: 3,
    name: "Cosmetics",
    image: "https://vexconquer.site/files1/items/cosmetics.png",
    price: 25,
    category: "Weapons",
      description: "Weapon Accessories are decorative items that supplement your weapons and make you stylish.",
  },
  {
      id: 4,
      name: "DBScroll",
      image: "https://vexconquer.site/files1/items/dbscroll.png",
      price: 12,
      category: "DBScroll",
      description: "Upgrade item quality, add sockets, and redistribute attribute points.",
  },
  {
      id: 5,
      name: "VIP 6",
      image: "https://vexconquer.site/files1/items/vip.png",
      price: 12,
      category: "VIP 6",
      description: "Remote Warehouse, Auto Loot, x5 EXP, Extra Stamina & Special Commands.",
    },
    {
        id: 6,
        name: "x10 Metsbag",
        image: "https://vexconquer.site/files1/items/metsbag.png",
        price: 20,
        category: "Featured",
        description: "Upgrade item levels and get a chance to obtain 1-socket or 2-socket items.",
    },
    {
        id: 7,
        name: "x5 Upgrade Token",
        image: "https://vexconquer.site/files1/items/Upgradetoken.png",
        price: 12,
        category: "Misc Items",
        description: "Quest item for high level upgrade gears, together with a dragonball to upgrade the item level.",
    },
    {
        id: 8,
        name: "x3 VIP 6",
        image: "https://vexconquer.site/files1/items/vip.png",
        price: 30,
        category: "VIP 6",
        description: "Remote Warehouse, Auto Loot, x5 EXP, Extra Stamina & Special Commands.",
    },

    {
        id: 9,
        name: "x5 SDG Package",
        image: "https://vexconquer.site/files1/items/sdg.png",
        price: 30,
        category: "Featured",
        description: "Get less for 20 dollars, buy x5 Super Dragon Gems.",
    },
    {
        id: 10,
        name: "x5 SRG Package",
        image: "https://vexconquer.site/files1/items/srg.png",
        price: 30,
        category: "Featured",
        description: "Get less for 20 dollars, buy x5 Super Rainbow Gems.",
    },
    {
        id: 11,
        name: "x5 SPG Package",
        image: "https://vexconquer.site/files1/items/spg.png",
        price: 30,
        category: "Featured",
        description: "Get less for 20 dollars, buy x5 Super Phoenix Gems.",
    },
    {
        id: 12,
        name: "x20 ProfToken Package",
        image: "https://vexconquer.site/files1/items/proftoken.png",
        price: 10,
        category: "Featured",
        description: "Use Proficiency Tokens to increase your proficiency level and equip higher-level items.",
    },
    {
        id: 13,
        name: "x5 DBScroll",
        image: "https://vexconquer.site/files1/items/dbscroll.png",
        price: 50,
        category: "DBScroll",
        description: "Upgrade item quality, add sockets, and redistribute attribute points.",
    }
]

export default storeItems;
